import { gql } from '@apollo/client/core';
import { bannerBlockFragment } from '../fragments/banner-block.fragment';
import { textBlockFragment } from '../fragments/text-block.fragment';
import { imageBlockFragment } from '../fragments/image-block.fragment';
import { buttonBlockFragment } from '../fragments/button-block.fragment';
import { richTextBlockFragment } from '../fragments/rich-text-block.fragment';
import { videoEmbedBlockFragment } from '../fragments/video-embed-block.fragment';
import { containerBlockFragment } from '../fragments/container-block.fragment';
import { signpostBlockFragment } from '../fragments/signpost-block.fragment';
import { accordionBlockFragment } from '../fragments/accordion-block.fragment';
import { galleryBlockFragment } from '../fragments/gallery-block.fragment';
import { htmlEmbedBlockFragment } from '../fragments/html-embed-block.fragment';
import { imageTextBlockFragment } from '../fragments/image-text-block.fragment';
import { downloadsBlockFragment } from '../fragments/downloads-block.fragment';

export const GET_HOME_PAGE_QUERY = gql`
  query GetHomePage {
    homeCollection(limit: 1) {
      items {
        entryTitle
        blocksCollection(limit: 20) {
          items {
            __typename
            ...TextBlockFields
            ...ImageBlockFields
            ...ButtonBlockFields
            ...BannerBlockFields
            ...RichTextBlockFields
            ...VideoEmbedBlockFields
            ...ContainerBlockFields
            ...SignpostBlockFields
            ...AccordionBlockFields
            ...GalleryBlockFields
            ...AccordionBlockFields
            ...HtmlEmbedBlockFields
            ...ImageTextBlockFields
            ...DownloadsBlockFields
          }
          __typename
        }
        __typename
      }
    }
  }
  ${textBlockFragment}
  ${imageBlockFragment}
  ${buttonBlockFragment}
  ${bannerBlockFragment}
  ${richTextBlockFragment}
  ${videoEmbedBlockFragment}
  ${containerBlockFragment}
  ${signpostBlockFragment}
  ${accordionBlockFragment}
  ${galleryBlockFragment}
  ${htmlEmbedBlockFragment}
  ${imageTextBlockFragment}
  ${downloadsBlockFragment}
`;
